var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBosniaandherzegovina({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_7766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0C7.74517 0 4.00783 2.21452 1.87708 5.5537L18.1502 22.3054C21.6537 20.21 24 16.3792 24 12C24 5.37262 18.6274 0 12 0Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 8.88647 22.8142 6.05015 20.8696 3.91743V20.0826C22.8142 17.9498 24 15.1135 24 12Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9901 22.5878L16.2471 22.587L16.6348 21.3913L17.024 22.5865L17.6544 22.5861C18.041 22.3792 18.4149 22.1518 18.7747 21.9051L2.0948 5.2252C1.81992 5.62626 1.56923 6.04504 1.34381 6.4791L1.49203 6.93435L2.74898 6.93356L1.73255 7.67301L2.1217 8.86827L1.10433 8.13009L0.497531 8.57146C0.174047 9.65784 0 10.8086 0 12C0 18.6274 5.37262 24 12 24C13.4012 24 14.7461 23.7594 15.9961 23.3179L14.9901 22.5878ZM2.67652 11.4783L3.06417 10.2826L2.04689 9.54431L3.30384 9.54351L3.69155 8.34777L4.0807 9.54304L5.33766 9.54224L4.32117 10.2817L4.71033 11.477L3.69295 10.7388L2.67652 11.4783ZM5.26519 14.087L5.65284 12.8913L4.63556 12.153L5.89252 12.1522L6.28022 10.9565L6.66937 12.1517L7.92633 12.1509L6.90989 12.8904L7.29905 14.0856L6.28167 13.3475L5.26519 14.087ZM7.85381 16.6956L8.24147 15.5L7.22419 14.7617L8.48114 14.7609L8.86884 13.5651L9.258 14.7604L10.515 14.7596L9.49851 15.4991L9.88767 16.6943L8.8703 15.9561L7.85381 16.6956ZM11.4589 18.5649L10.4424 19.3043L10.8301 18.1086L9.81281 17.3704L11.0698 17.3696L11.4575 16.1738L11.8467 17.3691L13.1036 17.3683L12.0872 18.1078L12.4763 19.303L11.4589 18.5649ZM13.0311 21.913L13.4188 20.7173L12.4015 19.9791L13.6584 19.9783L14.0461 18.7825L14.4353 19.9778L15.6922 19.977L14.6758 20.7164L15.065 21.9117L14.0476 21.1734L13.0311 21.913Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_7766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBosniaandherzegovina);
export default __webpack_public_path__ + "static/media/bosniaandherzegovina.7f87da6869d972f0e6f352769fbef584.svg";
export { ForwardRef as ReactComponent };